import React, { useRef, useEffect } from 'react'

const PDFPopup = ({ isOpen, onClose, pdfUrl, title = 'PDF Viewer' }) => {
  const popupRef = useRef(null)
  if (!isOpen) return null

  const viewerUrl = `${pdfUrl}#toolbar=0&navpanes=0&scrollbar=1`

  return (
    <div
      className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
      style={{
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        zIndex: 9999,
      }}
    >
      <div
        ref={popupRef}
        className="bg-white rounded shadow-lg pdf-viewer"
        style={{
          width: '50%',
          height: '100%',
          maxHeight: '90vh',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <div className="d-flex justify-content-between align-items-center p-3 border-bottom">
          <h5 className="mb-0">{title}</h5>
          <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
        </div>

        <div className="flex-grow-1">
          <embed src={viewerUrl} type="application/pdf" width="100%" height="100%" style={{ border: 'none' }} title={title} />
        </div>
      </div>
    </div>
  )
}

export default PDFPopup
